var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1 16.5L29.4 10.2C30.2 9.4 30.2 8.2 29.4 7.4L25.2 3.2C24.4 2.4 23.2 2.4 22.4 3.2L16 9.4L9.7 3.1C8.9 2.3 7.7 2.3 6.9 3.1L2.6 7.3C1.8 8.1 1.8 9.3 2.6 10.1L8.9 16.5L2 23.4V30.5H9.1L16 23.6L22.3 29.9C23.1 30.7 24.3 30.7 25.1 29.9L29.3 25.7C30.1 24.9 30.1 23.7 29.3 22.9L23.1 16.5ZM23.8 4.5L28 8.7L21.7 15L17.5 10.8L23.8 4.5ZM8.2 28.5H4V24.3L10.3 18L14.5 22.2L8.2 28.5ZM23.8 28.5L4 8.7L8.2 4.5L11.7 8L9.6 10.1L11 11.5L13.1 9.4L17.3 13.6L15.2 15.7L16.6 17.1L18.7 15L22.9 19.2L21 21.4L22.4 22.8L24.5 20.7L28 24.2L23.8 28.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.cbdc0b02cce6744bc39ca4d0c1bb12ca.svg";
export { ForwardRef as ReactComponent };